import FilterForm from 'components/forms/FilterForm';
import useSelectCourseByType from 'hooks/useSelectCourseByType';
import { ASSESSMENT_KIND_OPTIONS } from 'services/assessments';
import {
  Empty,
  Form,
  Input,
  Radio,
  RadioChangeEvent,
  Select,
  Space
} from 'antd';
import { FormProps } from 'antd/lib';
import { IAssessment } from 'interfaces/assessments';
import { SearchOutlined } from '@ant-design/icons';
import { useCallback } from 'react';

export interface IAssessmentsFilter {
  name: string;
  by_parent_id: string;
  by_parent_type: string;
  by_kind: IAssessment['kind'];
}

interface ListAssessmentsFilterProps {
  searchFormProps: FormProps<IAssessmentsFilter>;
}

export const AssessmentsFilter = ({
  searchFormProps
}: ListAssessmentsFilterProps) => {
  const { selectProps, selectedCourseType, setSelectedCourseType } =
    useSelectCourseByType();

  const onChangeType = useCallback(
    (e: RadioChangeEvent) => {
      const value = e.target.value;
      setSelectedCourseType(value);
    },
    [setSelectedCourseType]
  );

  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Space className="mb-0 bg-slate-100 rounded-md p-2">
        <Space align="center" size="small">
          <span className="text-gray-700">Tipo de curso:</span>
          <Form.Item
            name="by_parent_type"
            className="mb-0"
            initialValue="Course"
          >
            <Radio.Group
              onChange={onChangeType}
              value={selectedCourseType}
              defaultValue="Course"
            >
              <Radio.Button value="Course">Curso</Radio.Button>
              <Radio.Button value="Graduate::Discipline">
                Disciplina
              </Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Space>

        <Form.Item name="by_parent_id" className="mb-0 w-80">
          <Select
            placeholder={
              selectedCourseType === 'Course'
                ? 'Busque por curso'
                : 'Busque por disciplina'
            }
            allowClear
            {...selectProps}
            notFoundContent={
              <Empty
                description={`${
                  selectedCourseType === 'Course'
                    ? 'Nenhum curso encontrado'
                    : 'Nenhuma disciplina encontrada'
                }. Tente refazer sua busca com outros termos`}
              />
            }
          />
        </Form.Item>
      </Space>

      <Form.Item name="name" className="mb-0 w-80">
        <Input placeholder="Nome da avaliação" suffix={<SearchOutlined />} />
      </Form.Item>

      <Space className="mb-0 bg-slate-100 rounded-md p-2">
        <Space align="center" size="small">
          <span className="text-gray-700">Tipo da avaliação:</span>
          <Form.Item name="by_kind" className="mb-0" initialValue="">
            <Radio.Group>
              <Radio.Button value="">Todos</Radio.Button>
              {ASSESSMENT_KIND_OPTIONS.map(option => (
                <Radio.Button key={option.value} value={option.value}>
                  {option.label}
                </Radio.Button>
              ))}
            </Radio.Group>
          </Form.Item>
        </Space>
      </Space>
    </FilterForm>
  );
};
